export const IndependenceCheckmarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 12 8' aria-hidden='true' focusable='false' {...props}>
    <path
      d='M1 4L4 7L11 1'
      stroke='#365c16'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>
);
